





















import {Component, Prop, Vue} from 'vue-property-decorator';
import {CertificateCampData} from '@/views/media/certificate/components/certificate-camp';
import moment from 'moment';

@Component({})
export default class CertificateCamp2 extends Vue {

  @Prop() private campData: Array<CertificateCampData> | undefined;


  /**等级英文*/
  get courseLabel() {
    return `has participated in Ballet Camp of Balletme ${this.campData![0].level.label} for Ballet`;
  }

  /**时间中文*/
  get dateTimeText() {
    return `集训日期: ${moment(this.campData![0].begin_date).format('YYYY年MM月DD日')}-${moment(this.campData![0].end_date).format('YYYY年MM月DD日')}`;
  }

  /**时间英文*/
  get dateTimeLabel() {
    return `Date of Ballet Camp: ${moment(this.campData![0].begin_date).format('MM/DD/YYYY')}-${moment(this.campData![0].end_date).format('MM/DD/YYYY')}`;
  }
}
